<div class="mango-aws-item-upload" *ngIf="listView === 'grid'">
  <div class="progress-circle-upload" [ngClass]="{'completed': data.progress >= 100}">
    <i class="fa" [ngClass]="{
      'fa-image': classify === 'image',
      'fa-video': classify === 'video',
      'fa-file-archive': classify === 'archive',
      'fa-brain': classify === 'dicom'
    }"></i>
    <circle-progress
      *ngIf="!data.progress || data.progress < 100"
      [percent]="data.progress"
      [radius]="25"
      [outerStrokeWidth]="3"
      [innerStrokeWidth]="0"
      [outerStrokeColor]="'#4882C2'"
      [innerStrokeColor]="'##E7E8EA'"
      [animation]="false"
      [animationDuration]="300"
      [showSubtitle]="false"
      [space]="-10"
    ></circle-progress>
    <div class="image-preview"
         *ngIf="data.progress >= 100 && classify === 'image' && preview"
         [ngStyle]="{ 'background-image': 'url(' + preview + ')'}">
    </div>
  </div>

  <div class="details" *ngIf="type === 'folder'">
    <a href="javascript:void(0);">View Folder</a>
  </div>

  <div class="footer-left">
    <span>{{ data.file.name }}</span>
  </div>

  <div class="footer-right">
    <span [ngClass]="{
      'image-ext': classify === 'image',
      'zip-ext': classify === 'archive'
    }">{{ extension }}</span>
  </div>
</div>

<!-- inline -->

<div class="mango-aws-item-upload-inline" *ngIf="listView === 'list'" [ngClass]="{'inline-item': listView === 'list'}">
  <div class="inline-item">
    <div class="inline-wrapper">
      <div [ngClass]="{'completed': data.progress >= 100}">
        <i class="fa" [ngClass]="{
          'fa-image': classify === 'image',
          'fa-video': classify === 'video',
          'fa-file-archive': classify === 'archive',
          'fa-file': classify === 'document',
          'hide-icon': data.progress >= 100 && classify === 'image'
        }"></i>

        <div class="image-preview-inline"
             *ngIf="data.progress >= 100 && classify === 'image' && preview"
             [ngStyle]="{ 'background-image': 'url(' + preview + ')'}">
        </div>
      </div>

      <div class="inline-title">
        <span>{{ data.file.name }}</span>
      </div>

      <div>
        <span *ngIf="data.progress">{{ data.progress | number:'1.0-0' }}%</span>
        <span *ngIf="!data.progress">0%</span>
      </div>

      <div class="footer-right">
        <span [ngClass]="{
          'image-ext': classify === 'image',
          'zip-ext': classify === 'archive'
        }">{{ extension }}</span>
      </div>
    </div>

    <div>
      <progressbar *ngIf="data.progress < 100" [value]="data.progress"></progressbar>
      <!-- <progressbar [value]="50"></progressbar> -->
    </div>
  </div>
</div>
